(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  function setupDesktopHoverMenus() {
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const headerSection = document.querySelector('.section-header');
    const headerWrapper = headerSection ? headerSection.querySelector('.header-wrapper') : null;
    const header = headerSection ? headerSection.querySelector('.header') : null;

    if (!header || !headerWrapper) return;

    const menus = header.querySelectorAll('.header__inline-menu > .list-menu > li > header-menu > details');
    const fadeTime = 280;
    const closeDelay = 220;

    const closeAllOtherMenus = (currentDetails) => {
      menus.forEach((otherDetails) => {
        if (otherDetails !== currentDetails) {
          const otherSummary = otherDetails.querySelector('summary');

          otherDetails.classList.remove('is-hover-open', 'is-hover-closing');
          otherDetails.removeAttribute('open');

          if (otherSummary) {
            otherSummary.setAttribute('aria-expanded', 'false');
          }
        }
      });
    };

    const updateWrapperState = () => {
      const anyOpen = Array.from(menus).some((details) => details.hasAttribute('open'));

      if (anyOpen) {
        headerWrapper.classList.add('mega-hover-active');
      } else {
        headerWrapper.classList.remove('mega-hover-active');
      }
    };

    menus.forEach((details) => {
      if (details.dataset.hoverMenuReady === 'true') return;

      details.dataset.hoverMenuReady = 'true';

      const summary = details.querySelector('summary');
      const panel = details.querySelector('.mega-menu__content, .header__submenu');
      let closeTimer = null;
      let removeOpenTimer = null;

      const openMenu = () => {
        if (!desktopQuery.matches) return;

        window.clearTimeout(closeTimer);
        window.clearTimeout(removeOpenTimer);

        closeAllOtherMenus(details);

        details.classList.remove('is-hover-closing');
        details.classList.add('is-hover-open');
        details.setAttribute('open', '');

        if (summary) {
          summary.setAttribute('aria-expanded', 'true');
        }

        updateWrapperState();
      };

      const closeMenu = () => {
        if (!desktopQuery.matches) return;

        window.clearTimeout(closeTimer);
        window.clearTimeout(removeOpenTimer);

        closeTimer = window.setTimeout(() => {
          details.classList.remove('is-hover-open');
          details.classList.add('is-hover-closing');

          if (summary) {
            summary.setAttribute('aria-expanded', 'false');
          }

          removeOpenTimer = window.setTimeout(() => {
            details.removeAttribute('open');
            details.classList.remove('is-hover-closing');
            updateWrapperState();
          }, fadeTime);
        }, closeDelay);
      };

      const cancelClose = () => {
        if (!desktopQuery.matches) return;

        window.clearTimeout(closeTimer);
        window.clearTimeout(removeOpenTimer);

        details.classList.remove('is-hover-closing');
        details.classList.add('is-hover-open');

        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
        }

        if (summary) {
          summary.setAttribute('aria-expanded', 'true');
        }

        updateWrapperState();
      };

      details.addEventListener('mouseenter', openMenu);

      details.addEventListener('mouseleave', (event) => {
        if (panel && event.relatedTarget && panel.contains(event.relatedTarget)) {
          cancelClose();
          return;
        }

        closeMenu();
      });

      details.addEventListener('focusin', openMenu);

      details.addEventListener('focusout', (event) => {
        if (!details.contains(event.relatedTarget)) {
          closeMenu();
        }
      });

      if (panel) {
        panel.addEventListener('mouseenter', cancelClose);

        panel.addEventListener('mouseleave', (event) => {
          if (event.relatedTarget && details.contains(event.relatedTarget)) {
            cancelClose();
            return;
          }

          closeMenu();
        });
      }

      if (summary) {
        summary.addEventListener('click', (event) => {
          if (!desktopQuery.matches) return;

          event.preventDefault();

          if (details.hasAttribute('open')) {
            closeMenu();
          } else {
            openMenu();
          }
        });
      }
    });

    document.addEventListener('mousemove', (event) => {
      if (!desktopQuery.matches) return;

      const openDetails = header.querySelector('.header__inline-menu > .list-menu > li > header-menu > details[open]');

      if (!openDetails) return;

      const openPanel = openDetails.querySelector('.mega-menu__content, .header__submenu');

      if (
        openDetails.contains(event.target) ||
        header.contains(event.target) ||
        headerWrapper.contains(event.target) ||
        openPanel && openPanel.contains(event.target)
      ) {
        return;
      }

      openDetails.classList.remove('is-hover-open');
      openDetails.classList.add('is-hover-closing');

      window.setTimeout(() => {
        openDetails.removeAttribute('open');
        openDetails.classList.remove('is-hover-closing');
        updateWrapperState();
      }, fadeTime);
    });
  }

  setupDesktopHoverMenus();

  document.addEventListener('shopify:section:load', setupDesktopHoverMenus);

  } catch(e) { console.error(e); }
})();
})();
